import { useCallback, useEffect, useState } from 'react';
import {
  AI_FAB_DELAY_MS,
  readAiFabHidden,
  writeAiFabHidden,
} from '../services/ui/aiFabPrefs';

export function useAiFab(delayMs = AI_FAB_DELAY_MS) {
  const [dismissed, setDismissed] = useState(() => readAiFabHidden());
  const [ready, setReady] = useState(false);
  const [chatOpen, setChatOpen] = useState(false);

  useEffect(() => {
    if (dismissed) return undefined;
    const id = window.setTimeout(() => setReady(true), delayMs);
    return () => window.clearTimeout(id);
  }, [dismissed, delayMs]);

  const dismiss = useCallback(() => {
    setDismissed(true);
    setReady(false);
    setChatOpen(false);
    writeAiFabHidden(true);
  }, []);

  const openChat = useCallback(() => setChatOpen(true), []);
  const closeChat = useCallback(() => setChatOpen(false), []);
  const toggleChat = useCallback(() => setChatOpen((v) => !v), []);

  return {
    showFab: (ready && !dismissed) || chatOpen,
    dismissed,
    dismiss,
    chatOpen,
    openChat,
    closeChat,
    toggleChat,
    setChatOpen,
  };
}
